/* eslint-disable @next/next/no-img-element */
import React from 'react'
import Image from 'next/image'
import { LoginImage } from '@/src/assets/images'
import { useStore } from '@/src/types/store'
import { imageStyle, maskStyle, overlayStyle } from './loginBanner'

// Right-hand panel of sign in, register and forgot/reset password. The frame is
// kept empty while /theme is loading so the Relait banner never flashes before a
// custom one.
const AuthBanner = () => {
  const { homeTheme, themeColours, themeLoading } = useStore()
  const banner = homeTheme?.login_banner

  if (themeLoading) {
    return <div className="h-[100vh] aspect-[756/982]" />
  }
  if (!banner) {
    return <Image src={LoginImage} className="h-[100vh] aspect-auto" alt="login" />
  }
  return (
    <div className="relative h-[100vh] aspect-[756/982] overflow-hidden" style={maskStyle}>
      <img src={banner.url} alt="" style={imageStyle(banner)} />
      <div style={overlayStyle(banner, themeColours.primary, themeColours.secondary)} />
    </div>
  )
}

export default AuthBanner
